import { useMemo } from 'react'
import { useI18n, useRouter } from '@popety_io/popety-io-lib'

import LegendSelector from '../../../../../components/LegendSelector'
import { legends } from './utils'

const EstimatePopulationContent = () => {
  const { t } = useI18n()
  const { query } = useRouter()

  const mapLegends = useMemo(() => {
    return legends?.[query.populationLayer || 'total_population'] || []
  }, [query.populationLayer])

  const options = [
    {
      value: 'total_population',
      label: t('common.population.total_population'),
    },
    {
      value: 'total_population_most_represented_age',
      label: t('common.population.total_population_most_represented_age'),
    },
    {
      value: 'total_population_most_represented_households_number',
      label: t(
        'common.population.total_population_most_represented_households_number',
      ),
    },
    {
      value: 'total_population_most_represented_residents_city_time',
      label: t(
        'common.population.total_population_most_represented_residents_city_time',
      ),
    },
    {
      value: 'number_residents_city_0_1_year',
      label: t('common.population.number_residents_city_0_1_year'),
    },
  ]

  return (
    <div>
      <LegendSelector
        options={options}
        legends={mapLegends}
        keyValue="populationLayer"
        legendValue="populationLegend"
        value="total_population"
      />
    </div>
  )
}

export default EstimatePopulationContent
